/**
 * "Op dit moment populair" (sectie featured_collections_tabs_VQx9j6): op mobiel
 * is het productgrid een rij die je opzij scrolt in plaats van twee kolommen
 * onder elkaar (zie section-featured-collections-tabs.css). Deze chevrons
 * schuiven die rij een kaart op en gaan uit zodra je aan het begin of het eind
 * staat - dezelfde bediening als de reviewcarrousel
 * (component-video-product-cards.js) en de collectierij erboven.
 *
 * Vanaf 900px verbergt section-video-product-cards.css de knoppen; het grid
 * staat daar toch in zijn geheel in beeld.
 */
(function () {
  function init() {
    document
      .querySelectorAll('.featured-collections--mobile-row [data-mobile-row-nav]')
      .forEach(setup);
  }

  function setup(nav) {
    if (nav.dataset.mobileRowReady === 'true') return;

    // Elk tabblad heeft zijn eigen rij, dus de track komt uit dezelfde
    // slideshow-section als de knoppen.
    var group = nav.closest('[data-slides-group]') || nav.parentElement;
    var track = group && group.querySelector('[data-swiper-container]');
    if (!track) return;

    var prev = nav.querySelector('[data-mobile-row-prev]');
    var next = nav.querySelector('[data-mobile-row-next]');
    if (!prev && !next) return;

    nav.dataset.mobileRowReady = 'true';

    function step() {
      var slide = track.querySelector('[data-swiper-slide]');
      if (!slide) return 0;
      var gap = parseFloat(window.getComputedStyle(track).columnGap);
      return slide.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
    }

    function scrollByCard(direction) {
      var amount = step();
      if (!amount) return;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    var frame = null;
    function sync() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        var max = track.scrollWidth - track.clientWidth;
        // scrollLeft is negatief in RTL, de afstand tot het begin is dezelfde.
        var position = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = position <= 1;
        if (next) next.disabled = position >= max - 1;
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByCard(1);
      });
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    // Een verborgen tabblad heeft geen breedte, dus daar klopt de meting pas
    // zodra het paneel getoond wordt.
    var panel = nav.closest('[role="tabpanel"]');
    if (panel && window.MutationObserver) {
      new MutationObserver(sync).observe(panel, {
        attributes: true,
        attributeFilter: ['hidden'],
      });
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // De theme-editor rendert een sectie opnieuw met nieuwe DOM-nodes.
  document.addEventListener('shopify:section:load', init);
})();
